import React from 'react';
import ReactDOM from 'react-dom/client'; // Import createRoot from react-dom/client

import * as serviceWorker from './serviceWorker';
import App from './App';
import { Provider } from 'react-redux';

import { configureStore } from "store";
const store = configureStore();
// Create a root.
const root = ReactDOM.createRoot(document.getElementById('root'));

// Initial render
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>

  </React.StrictMode>
);

// Unregister the service worker if needed
serviceWorker.unregister();
